const productsAnim = {
  init() {
    document.addEventListener("DOMContentLoaded", () => {
      /* GSAP */

      //H1 BANNER
      let split = SplitText.create(".header h1", { type: "lines" });

      gsap.from(split.lines, {
        rotationX: 50,
        transformOrigin: "50% 50% -160px",
        opacity: 0,
        duration: 0.8,
        ease: "power3",
        stagger: 0.25,
      });

      //PRODUITS
     

        gsap.from('.product', {
          scale: 0.3,
          opacity: 0,
          duration: 0.8,
          ease: "power3",
          stagger: 0.25,
          scrollTrigger: {
            trigger: '.products-list',
            start: "top+=100 80%",
            end: "bottom top",
            scrub: false,
            markers: false,
            toggleActions: "play none none reverse",
          },
        });


      

      
    });
  },
};

export default productsAnim;
